import { render, staticRenderFns } from "./AddVendor.vue?vue&type=template&id=1f2373a4&scoped=true"
import script from "./AddVendor.vue?vue&type=script&lang=js"
export * from "./AddVendor.vue?vue&type=script&lang=js"
import style0 from "./AddVendor.vue?vue&type=style&index=0&id=1f2373a4&prod&scoped=true&lang=scss"
import style1 from "./AddVendor.vue?vue&type=style&index=1&id=1f2373a4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2373a4",
  null
  
)

export default component.exports